export const DATA = {
  UNABLE_TO_TALK: "I'm panting, unable to talk",
  HARD: "I'm slightly out of breath, still able to talk",
  AVERAGE: "I'm OK after one flight of stairs",
  EASY: "I can handle a few flights of stairs",
};
